type HelpRouteContext = {
  pattern: RegExp;
  pageName: string;
  pageTitle: string;
  topicName: string;
  query?: Record<string, string>;
};

export const KNOWN_HELP_ROUTES: HelpRouteContext[] = [
  {
    pattern: /^\/signin$/,
    pageName: 'getting-started',
    pageTitle: 'Getting Started: Signup, Login & Account Setup',
    topicName: 'Signin'
  },
  {
    pattern: /^\/signin\/forgotpassword$/,
    pageName: 'getting-started',
    pageTitle: 'Getting Started: Signup, Login & Account Setup',
    topicName: 'Forgot Password'
  },
  {
    pattern: /^\/signup$/,
    pageName: 'getting-started',
    pageTitle: 'Getting Started: Signup, Login & Account Setup',
    topicName: 'Signup & Account Setup'
  },
  {
    pattern: /^\/app\/journal-index$/,
    pageName: 'submitting-manuscript',
    pageTitle: 'Submitting a Manuscript',
    topicName: 'Getting Started with a Submission'
  },
  {
    pattern: /^\/j\/[^/]+$/,
    pageName: 'submitting-manuscript',
    pageTitle: 'Submitting a Manuscript',
    topicName: 'Uploading Files & Metadata'
  }
];

type HelpRouteResult = {
  matched: boolean;
  topicName?: string;
  pageName?: string;
  pageTitle?: string;
};

export function getHelpRouteContext(url: string): HelpRouteResult {
  const parsedUrl = new URL(url, window.location.origin);
  const route = KNOWN_HELP_ROUTES.find(route => {
    if (!route.pattern.test(parsedUrl.pathname)) {
      return false;
    }

    if (route.query) {
      return Object.entries(route.query).every(
        ([key, value]) => parsedUrl.searchParams.get(key) === value
      );
    }

    return true;
  });

  return route
    ? {
        matched: true,
        topicName: route.topicName,
        pageName: route.pageName,
        pageTitle: route.pageTitle
      }
    : {
        matched: false
      };
}
